const color = {
    transparent: "#00000000",
    whiteSmoke: "#F5F5F5",
    whiteSmokeOpacity: "rgba(245, 245, 245, 0.5)",
    grey300: "#E0E0E0",
    grey500: "#9E9E9E",
    grey600: "#757575",  // 54% black
    grey700: "#616161",
    grey900: "#212121", // 87% black
    black: "#000000",
    yellow: "#f5a522",

    pink100: "#F8BBD0",
    orange500: "#FF8000",
    orange800: "#EF6C00",

    lightGreen500: "#8BC34A",
    lightGreen600: "#7CB342",
    lightGreen700: "#689F38",
    lightGreen800: "#558B2F",

    deepPurple500: "#673AB7",
    greyOut: "grey",
    routeColor: "#263238",
    aluminium: "#81898D",
    aluminiumshade: "#848d90",
    solitude: "#ECEDEE",
    white: "#FFFFFF",
    routeColorOpacity: "rgba(38, 50, 56, 0.3)",

    ghostWhite: "#F4F5F9",
    zumthor: "#D1D5D6",
    aliceBlue: "#F1F4F8",
    greyChateau: "#979CA6",
    stormGrey: "#7C7E82",
    casper: '#B3B6B7',
    solitudeDark: '#DFE6ED',
    slateGrey: '#78808D',
    eastBay: "#465061",
    echoBlue: "#b6bac2",
    spindle: "#bec9d0",
    pattensBlue: "#CFD8DC",
    midnightExpress: "#000033",
    cornflowerBlue: "#448AFF",
    red: "red",
    green: "green",
    quartz: "#E0E0E2",
    kellyGreen: "#50C900",
    lightgrey: "lightgrey",
    trout: "#48555A",
    iron: '#C7CBCDc',
    paleSky: '#596469',
    silver: "#c3c3c3",
    linkWater: "#cdd2d6",
    venetianRed: "#D0021B",
    lightningYellow: "#F5A623",
    baliHai: "#90989b",
    
    HomeButtonBGColor: '#FAFBFC',
    HomeButtonTxtColor: '#354052',
    FooterTextColor: '#899194',
    CancelTripWarnIconColor: '#fe5959',
    AppScreensBackgroundColor: 'rgba(241,242,248,1)',
    HomeButtonsShadowColor: 'rgba(66.3, 117.3, 150.4, 0.24)',
    HomeGreetingColor: 'rgba(40, 49, 64, 1)',

    AppGreen: '#5CDB95',
    AppButtonBlue: '#05386b',

    appColors: {
        primaryBg: '#5CDB95',
        primaryBgContrast: '#05386b'
    }
    
    // get primary() { return this.lightGreen600; },
    // get primary() { return this.submitButtonBGColor; },
    // get primaryTranslucent() { return this.submitButtonBGColor + "B3" }, // 70% opacity
    // get primaryDark() { return this.lightGreen700; },
    // get accent() { return this.deepPurple500; },

    // get mainTextColor() { return this.grey900; },
    // get secondaryTextColor() { return this.grey600; },

    //get vehicleIconColor() { return brand.mobileUI.colorScheme.vehicleColor },
    // get vehicleIconColor() { return '#000000' },

    // black with 20% opacity
    //get translucent() { return this.black + "33" },
    

    // get modalBackground() { return this.black + "99"; },

    // white with 20% opacity
    // get translucentLight() { return this.whiteSmoke + "33" },

    // For dev purpose
    // get reserved() { return this.pink100; },



};

export default color;